/* eslint-disable */
export default function init(Blockly, profile, img_path) {
  Blockly.Blocks.sensor = {};
  Blockly.Blocks.sensor.style = "sensor_blocks";
  Blockly.Blocks.sensor_potentiometer = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_POT)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_pot.svg", 45, 45)
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].analog),
          "PIN"
        )
        .appendField(
          new Blockly.FieldDropdown(profile["default"].sensor_range),
          "RANGE"
        );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_potentiometer_lite = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
          .appendField(Blockly.Msg.SENSOR_POT)
          .appendField(
              new Blockly.FieldImage(img_path + "arduino/sensor_pot.svg", 45, 45)
          )
          .appendField(Blockly.Msg.SENSOR_PIN)
          .appendField(
              new Blockly.FieldDropdown(profile["arduino_uno_lite"].potentiometer),
              "PIN"
          )
          .appendField(
              new Blockly.FieldDropdown(profile["default"].sensor_range),
              "RANGE"
          );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_button = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_BUTTON)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_button.svg", 50, 50)
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "PIN"
        );
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_BUTTON_INVERT)
        .appendField(new Blockly.FieldCheckbox("FALSE"), "INVERT");
      this.setInputsInline(!0);
      this.setOutput(!0, "Boolean");
    },
  };
  Blockly.Blocks.sensor_button_lite = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
          .appendField(Blockly.Msg.SENSOR_BUTTON)
          .appendField(
              new Blockly.FieldImage(img_path + "arduino/sensor_button.svg", 50, 50)
          )
          .appendField(Blockly.Msg.SENSOR_PIN)
          .appendField(
              new Blockly.FieldDropdown(profile["arduino_uno_lite"].digital),
              "PIN"
          );
      this.appendDummyInput("")
          .appendField(Blockly.Msg.SENSOR_BUTTON_INVERT)
          .appendField(new Blockly.FieldCheckbox("FALSE"), "INVERT");
      this.setInputsInline(!0);
      this.setOutput(!0, "Boolean");
    },
  };
  Blockly.Blocks.sensor_button_debounced = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_BUTTON_DEBOUNCED)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_button.svg", 50, 50)
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "PIN"
        )
        .appendField(
          new Blockly.FieldDropdown([
            [Blockly.Msg.SENSOR_BUTTON_DEBOUNCED_PRESSED, "pressed"],
            [Blockly.Msg.SENSOR_BUTTON_DEBOUNCED_RELEASED, "released"],
          ]),
          "STATUS"
        );
      // this.appendDummyInput("")
      //   .appendField(Blockly.Msg.SENSOR_BUTTON_INVERT)
      //   .appendField(new Blockly.FieldCheckbox("FALSE"), "INVERT");
      this.setInputsInline(!0);
      this.setOutput(!0, "Boolean");
    },
  };
  Blockly.Blocks.sensor_button_debounced_lite = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
          .appendField(Blockly.Msg.SENSOR_BUTTON_DEBOUNCED)
          .appendField(
              new Blockly.FieldImage(img_path + "arduino/sensor_button.svg", 50, 50)
          )
          .appendField(Blockly.Msg.SENSOR_PIN)
          .appendField(
              new Blockly.FieldDropdown(profile["arduino_uno_lite"].digital),
              "PIN"
          )
          .appendField(
              new Blockly.FieldDropdown([
                [Blockly.Msg.SENSOR_BUTTON_DEBOUNCED_PRESSED, "pressed"],
                [Blockly.Msg.SENSOR_BUTTON_DEBOUNCED_RELEASED, "released"],
              ]),
              "STATUS"
          );
      // this.appendDummyInput("")
      //   .appendField(Blockly.Msg.SENSOR_BUTTON_INVERT)
      //   .appendField(new Blockly.FieldCheckbox("FALSE"), "INVERT");
      this.setInputsInline(!0);
      this.setOutput(!0, "Boolean");
    },
  };
  Blockly.Blocks.sensor_dht22 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_DHT22)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_dht22.svg", 50, 50)
        )
        .appendField(
          new Blockly.FieldDropdown([
            [Blockly.Msg.SENSOR_TEMPERATURE, "temperature"],
            [Blockly.Msg.SENSOR_HUMIDITY, "humidity"],
          ]),
          "TYPE"
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "PIN"
        );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_dht11 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_DHT11)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_dht11.svg", 50, 50)
        )
        .appendField(
          new Blockly.FieldDropdown([
            [Blockly.Msg.SENSOR_TEMPERATURE, "temperature"],
            [Blockly.Msg.SENSOR_HUMIDITY, "humidity"],
          ]),
          "TYPE"
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "PIN"
        );
      this.setOutput(true, "Number");
    },
  };
  Blockly.Blocks.sensor_ultrasonic = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_ULTRASONIC)
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/sensor_ultrasonic.svg",
            100,
            50
          )
        )
        .appendField("Trigger")
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "TRIGGER_PIN"
        )
        .appendField("Echo")
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "ECHO_PIN"
        )
        .appendField(Blockly.Msg.SENSOR_ULTRASONIC_UNITS)
        .appendField(
          new Blockly.FieldDropdown([
            ["cm", "cm"],
            ["in", "in"]
          ]),
          "UNITS"
        );
      this.setInputsInline(true);
      this.setOutput(true, "Number");
    },
  };
  Blockly.Blocks.sensor_ultrasonic2 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_ULTRASONIC)
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/sensor_ultrasonic.svg",
            50,
            40
          )
        )
        .appendField("[Trigger]")
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "TRIGGER_PIN"
        )
        .appendField("[Echo]")
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "ECHO_PIN"
        );
      this.appendValueInput("MAXDISTANCE", "Number")
        .appendField(Blockly.Msg.SENSOR_ULTRASONIC_MAXDISTANCE)
        .setCheck("Number");
      this.setInputsInline(!0);
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_tmp36 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_TMP36)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_tem36.svg", 50, 50)
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].analog),
          "PIN"
        );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_tilt = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_TILT)
        .appendField(new Blockly.FieldImage(img_path + "arduino/sensor_tilt.svg", 50, 50))
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(new Blockly.FieldDropdown(profile["default"].digital),"PIN");
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_BUTTON_INVERT)
        .appendField(new Blockly.FieldCheckbox("FALSE"), "INVERT");
      this.setInputsInline(true);
      this.setOutput(true, "Boolean");
    },
  };
  Blockly.Blocks.sensor_tilt_lite = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
          .appendField(Blockly.Msg.SENSOR_TILT)
          .appendField(new Blockly.FieldImage(img_path + "arduino/sensor_tilt.svg", 50, 50))
          .appendField(Blockly.Msg.SENSOR_PIN)
          .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].digital),"PIN");
      this.appendDummyInput("")
          .appendField(Blockly.Msg.SENSOR_BUTTON_INVERT)
          .appendField(new Blockly.FieldCheckbox("FALSE"), "INVERT");
      this.setInputsInline(true);
      this.setOutput(true, "Boolean");
    },
  };
  Blockly.Blocks.sensor_sound = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_SOUND)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_sound.svg", 50, 50)
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].analog),
          "PIN"
        )
        .appendField(
          new Blockly.FieldDropdown(profile["default"].sensor_range),
          "RANGE"
        );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_TEMT6000 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_TEMT6000)
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/sensor_TEMT6000.svg",
            50,
            40
          )
        )
        .appendField(Blockly.Msg.SENSOR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].analog),
          "PIN"
        )
        .appendField(
          new Blockly.FieldDropdown(profile["default"].sensor_range),
          "RANGE"
        );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_TEMT6000_lite = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
          .appendField(Blockly.Msg.SENSOR_TEMT6000)
          .appendField(
              new Blockly.FieldImage(
                  img_path + "arduino/sensor_TEMT6000.svg",
                  50,
                  40
              )
          )
          .appendField(Blockly.Msg.SENSOR_PIN)
          .appendField(
              new Blockly.FieldDropdown(profile["arduino_uno_lite"].potentiometer),
              "PIN"
          )
          .appendField(
              new Blockly.FieldDropdown(profile["default"].sensor_range),
              "RANGE"
          );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.sensor_adxl345 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      //this.setTooltip("");
      this.setStyle(Blockly.Blocks.sensor.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_ACCEL_ADXL345)
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/sensor_adxl345.svg",
            50,
            50
          )
        );
      this.appendDummyInput("").appendField(
        new Blockly.FieldDropdown([
          ["Acc X (m/s\u00b2)", "4"],
          ["Acc Y (m/s\u00b2)", "5"],
          ["Acc Z (m/s\u00b2)", "6"],
          ["Roll X (\u00ba)", "7"],
          ["Pitch Y (\u00ba)", "8"],
          ["Acc X (raw)", "1"],
          ["Acc Y (raw)", "2"],
          ["Acc Z (raw)", "3"],
        ]),
        "ID"
      );
      this.appendDummyInput("")
        .appendField(Blockly.Msg.SENSOR_ACCEL_OFFSET)
        .appendField(new Blockly.FieldCheckbox("FALSE"), "OFFSET");
      this.setInputsInline(true);
      this.setOutput(true, "Number");
    },
  };
}
